export const commonState = state => state.common;
